import React, {useState, useEffect} from 'react';
import {Form, Select, DatePicker} from 'antd';
import { getStocksAsSelect } from "../../../services/serviceStock";
import { getBrandsAsSelect } from "../../../services/serviceBrand";
import { getEmployeesAsSelect } from "../../../services/serviceEmployee";
import config from '../../../config';

const {RangePicker} = DatePicker;


const BrandClusterFilter = () => {
    const [stocks, setStocks] = useState([]);
    const [brands, setBrands] = useState([]);
    const [employee, setEmployee] = useState([]);

    useEffect(() => {
        getStocksAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.label}));
                    setStocks(structured);
                }
            })
    }, [])

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map((item) => ({value: item.key, label:item.label}));
                    setBrands(structured);
                }
            })
    }, [])

    useEffect(() => {
        getEmployeesAsSelect()
            .then(({data}) => {
                const structured = data.map(({value, label}) => ({value: value, label: label}));
                setEmployee(structured);
            })
    }, [])

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    return(
        <React.Fragment>
            <Form.Item
                name={'dateRange'}
                label={'Tarih Aralığı'}
            >
                <RangePicker format={config.userDateFormat} />
            </Form.Item>
             <Form.Item
                name={'stockId'}
                label={'Stok Adı'}
            >
                <Select showSearch options={stocks} filterOption={selectSearch} />
            </Form.Item>
            <Form.Item
                name={'employee'}
                label={'Çalışan'}
                rules={[
                    {required: true, message:'Bu Alan Zorunludur'}
                ]}
            >
                <Select showSearch options={employee} filterOption={selectSearch}/>
            </Form.Item>
            <Form.Item
                name={'brandId'}
                label={'Marka Adı'}
            >
                <Select showSearch options={brands} filterOption={selectSearch}/>
            </Form.Item>
        </React.Fragment>
    )
}

export default BrandClusterFilter;